// TODO: 需要 style/css parse
export function parseStyle(styleString = '') {
    if (!styleString) {
        return {};
    }
    const result = {};
    styleString.split(';').forEach((piece) => {
        if (piece.trim()) {
            const colonPos = piece.indexOf(':');
            const name = piece.slice(0, colonPos).trim();
            const value = piece.slice(colonPos + 1).trim();
            result[name] = value;
        }
    });
    return result;
}
export function stringifyStyles(styles = {}) {
    return Object.entries(styles)
        .map(([name, value]) => `${name}:${value}`)
        .join(';');
}
//# sourceMappingURL=utils.js.map